import {AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PlayerBaseService} from '../../services/PlayerService/player.base.service';
import {Log, LogTag} from '../../services/Log';
import {concatMap, filter, fromEvent, Observable, of, repeatWhen, Subject, tap} from 'rxjs';
import {catchError, delay, retryWhen, take} from "rxjs/operators";
import {RegDialogComponent} from "../reg-dialog/reg.dialog.component";
import {retryWithBackoff} from "../../rxjs/retryWithBackoff";

@Component({
    selector: 'app-host-server',
    templateUrl: './host-server.component.html',
    styleUrls: ['../reg-dialog/reg.dialog.component.css', './host-server.component.css']
})
export class HostServerComponent extends RegDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('hostType', {static: true}) hostType;
  @ViewChild('domain', {static: true}) domain;
  @ViewChild('connect', {static: true}) connect;
  @ViewChild('container', {static: false}) container: ElementRef;

  selectedOption: string;
  showPrivateServer = false;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.selectedOption = 'defaultServer';
    this.onHost();
  }

  ngAfterViewInit() {
    // todo: remove first screen as we dont support private server, yet.and when we do it should be in side bar, as almost no clients use private server
    if (this.showPrivateServer) return;
    setTimeout(() => this.onClick());
  }

  public getHost(): Observable<any> {
    const logInfo = Log.getLogInfo("HostServerComponent", "getHost", []);
    return this.click$.pipe(
      concatMap(value => {
        Log.d(logInfo, LogTag.REGISTRATION, 'Host click()');
        this.playerService.domain = this.domain.nativeElement.value;
        const url = 'https://' + this.playerService.domain + '/Web/domain.ashx';
        Log.d(logInfo, LogTag.REGISTRATION, 'url=' + url);
        return this.http.get(url, {responseType: 'text'}).pipe(
          retryWithBackoff()
        )
      }),
      filter(res => {
        return (res != null);
      }),
      take(1)
    )
  }

  onHost() {
    if (this.selectedOption == 'defaultServer') {
      this.domain.nativeElement.value = 'galaxy.signage.me';
      this.domain.nativeElement.hidden = true;
    } else {
      this.domain.nativeElement.value = '';
      this.domain.nativeElement.hidden = false;
    }
  }
}
